<div class="inline-flex">
    @for (option of options(); track option; let i = $index) {
        <button
                (click)="onButtonClick(option)"


                class="
                px-4 py-2
                text-xs font-medium
                border-2 border-gray-300
                text-gray-700
                first:rounded-l-full
                last:rounded-r-full
                -ml-px
                flex items-center
                transition
                duration-150
                ease-in-out
                leading-3
            "
                [ngClass]="{
                    'bg-primary-200': option === selectedValue(),
                    'hover:bg-primary-200': option === selectedValue() && !disabled(),
                    'hover:bg-primary-50': option !== selectedValue() && !disabled(),
                    'ml-0': i === 0
                  }"

                [class.opacity-50]="disabled()"
                [class.cursor-not-allowed]="disabled()"
                [attr.aria-disabled]="disabled()"
        >
            @if (option === selectedValue()) {
                <svg
                        class="w-4 h-4 mr-2 text-primary animate-flip-up"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                >
                    <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="4"
                            d="M5 13l4 4L19 7"
                    />
                </svg>
            }


            {{ translated() ? (option | translate) : option }}
        </button>
    }
</div>
